export default __webpack_public_path__ + "static/media/rk8.d2f4474d.png";